import WealthWithLeeLogo from '@/assets/branding/wealthwithlee/wealthwithlee-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#5DB858',
  brand_primary_hover: '#4E924B', // −10 L, −8 S
  brand_primary_highlight: '#A9DFA6', // +23 L, +7 S
  brand_primary_mid: '#77C673', // +8 L,  +2 S
  brand_primary_dark: '#30632D', // −25 L, −3 S
  brand_secondary: '#477C48', // hue +4°, −15 L, −13 S
  brand_accent_start: '#6CC666',
  brand_accent_end: '#4F97D1',
  brand_accent_light_start: '#F0FAEE',
  brand_accent_light_end: '#E2F0FB',
  brand_complementary_accent: 'rgb(214,69,222)',
  brand_auth_gradient_mid: '#477C48',
  brand_auth_gradient_end: '#30632D',
  brand_auth_warp_mid: '#77C673',
};

export default {
  name: 'Wealth With Lee',
  isSAML: true,
  allowPersonalCourses: false,
  logo: WealthWithLeeLogo,
  colors,
};
